export const MGID_SITE_ID =
  process.env.NEXT_PUBLIC_MGID_INIT?.trim() ||
  process.env.MGID_INIT?.trim() ||
  '1071125';

export const MGID_SITE_SCRIPT_SRC = `https://jsc.mgid.com/site/${MGID_SITE_ID}.js`;

const MGID_SITE_SCRIPT_ID = `mgid-site-${MGID_SITE_ID}`;

/** @type {Promise<void> | null} */
let loadPromise = null;
/** @type {ReturnType<typeof setTimeout> | null} */
let mgcLoadTimer = null;

export function loadMgidSiteScriptOnce() {
  if (typeof document === 'undefined') {
    return Promise.resolve();
  }

  const mounted = document.getElementById(MGID_SITE_SCRIPT_ID);
  if (mounted?.getAttribute('data-mgid-loaded') === '1') {
    return Promise.resolve();
  }

  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.id = MGID_SITE_SCRIPT_ID;
    script.src = MGID_SITE_SCRIPT_SRC;
    script.async = true;

    script.addEventListener(
      'load',
      () => {
        script.setAttribute('data-mgid-loaded', '1');
        resolve();
      },
      { once: true }
    );
    script.addEventListener(
      'error',
      () => {
        loadPromise = null;
        reject(new Error('MGID site script error'));
      },
      { once: true }
    );

    document.head.appendChild(script);
  });

  return loadPromise;
}

export function ensureMgidSiteAndQueueLoadOnce() {
  return loadMgidSiteScriptOnce().then(() => {
    if (typeof window === 'undefined') {
      return;
    }
    window._mgq = window._mgq || [];
    if (mgcLoadTimer) {
      clearTimeout(mgcLoadTimer);
    }
    mgcLoadTimer = setTimeout(() => {
      mgcLoadTimer = null;
      window._mgq = window._mgq || [];
      window._mgq.push(['_mgc.load']);
    }, 50);
  });
}
